import * as React from 'react';
import { SVGProps } from 'react';

const PaymentLinksSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m11.757 20.242 8.485-8.486M18.12 22.364l-3.535 3.535a6 6 0 1 1-8.486-8.485l3.536-3.536M22.363 18.12l3.536-3.535A6 6 0 0 0 17.414 6.1l-3.536 3.535'
    />
  </svg>
);

export default PaymentLinksSidebar;
